import { z } from "zod";

export const updateSponsoredContentSchema = z
	.object({
		image_url: z.url({ message: "Invalid image URL" }).optional(),
		cta_url: z.url({ message: "Invalid CTA URL" }).optional(),
		cta_label: z.string().max(100).optional(),
		active: z.boolean().optional(),
	})
	.strict();

export type UpdateSponsoredContentPayload = z.infer<typeof updateSponsoredContentSchema>;
